const service = function(
	Http,
) {
	"ngInject";

	var user

	this.get = (data) => Http.get('/v1/user', false, data);
	this.update = (data) => Http.post('/v1/user', 'POST', data);
	this.setPushToken = (token) => Http.post('/v1/user/push-token', 'POST', { token: token });
	this.categories = () => Http.get('/v1/user/categories');
	this.views = () => Http.get('/v1/user/views');
	this.storeCategories = (list) => Http.post('/v1/user/categories', 'POST', { list: list });
	this.clearViews = () => Http.post('/v1/user/views', 'DELETE');
}

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/user.service.js